export default __webpack_public_path__ + "static/media/eye.b8cad0cf.svg";